import { Box, Link } from '@mui/material';
import PageArea from '../../../components/shared/PageArea';
import PageTitle from '../../../components/shared/PageTitle';
import Products from '../OrderableItems/components/Products';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { UserContext } from '../../../components/shared/useUser';
import { useContext } from 'react';
import CustomBreadCrumbs from '../../../components/ui/CustomBreadCrumbs';

const ProductsListOfd = () => {
  const { t } = useTranslation('products');
  const { id } = useParams();
  const { hasPermissionTo } = useContext(UserContext);

  return (
    <PageArea>
      <CustomBreadCrumbs title={`${t('orderTitle')} `}>
        {hasPermissionTo(['OrdersView']) ?
          <Link to="/orders"
            component={RouterLink}>{t('orders')}</Link> : null}
        {hasPermissionTo(['OrdersView']) ?
          <Link to={`/order/${id}`}
            component={RouterLink}>{t('order') + ': ' + id }</Link> : null}
      </CustomBreadCrumbs>
      <Box
        display='flex'
        flexDirection='column'
        flex={1}
        alignItems='start'
      >
        <PageTitle>{t('orderTitle')}</PageTitle>
      </Box>     
      <Box
        display='flex'
        flexDirection='column'
        flex={1}
      >
        <Products orderIdString={id} />
      </Box>
    </PageArea>
  );
};

export default ProductsListOfd;